module.exports = __webpack_public_path__ + "img/video.4eb59682.png";